@if (task$ | async; as task) {
  <div [tooltipTrigger]="showTooltip ? template : null">
    <!-- Task Card Display Mode: calendar -->
    @if (displayMode === "calendar") {
      @if (displayMode === "calendar") {
        <div
          class="small"
          [ngStyle]="BuildStateStyle(stateMeta)"
          tooltip
          (dblclick)="OnOpenTask(task)"
        >
          <container-element>
            @switch (task.appointmentArrangement) {
              @case (appointmentArrangement.Required) {
                <td>
                  <div>
                    <mat-icon
                      color="error"
                      style="
                        font-size: 16px;
                        width: 18px;
                        height: 18px;
                        transform: translateY(2px);
                        text-shadow:
                          -1px -1px 0 #fff4,
                          1px -1px 0 #fff4,
                          -1px 1px 0 #fff4,
                          1px 1px 0 #fff4;
                      "
                      i18n-title="@@AppointmentArrangement_Required_Tooltip"
                      title="Appointment must be made"
                      >perm_phone_msg</mat-icon
                    >
                  </div>
                </td>
              }
              @case (appointmentArrangement.Scheduled) {
                <td>
                  <mat-icon
                    style="
                      font-size: 16px;
                      width: 18px;
                      height: 18px;
                      transform: translateY(2px);
                    "
                    i18n-title="@@AppointmentArrangement_Scheduled_Tooltip"
                    title="Appointment scheduled"
                    >event</mat-icon
                  >
                </td>
              }
            }
          </container-element>
          <span [ngStyle]="BuildTextStyle()"
            ><span>{{ task?.label }}</span></span
          >
          @if (HasResource(task)) {
            <span [ngStyle]="BuildTextStyle()"
              ><br />{{ GetResourceName(task) }}</span
            >
          }
          @if (task.description) {
            <span [ngStyle]="BuildTextStyle()"
              ><br />{{ GetShortenedDescription(task) }}</span
            >
          }
        </div>
      }
    }

    <!-- Task Card Display Mode: list -->
    @if (displayMode === "list") {
      <div
        class="task-card task-card-planitem"
        [ngStyle]="BuildStateStyle(stateMeta)"
        [attr.task-id]="task?.id"
        #card
        tooltip
        [ngClass]="task?.claimResourceID ? 'claimed' : null"
        (dblclick)="OnOpenTask(task)"
      >
        <div class="small">
          <table class="card-list-table">
            <tr>
              <td class="text-ellipsis">
                @if (task?.category) {
                  <span>{{ task.category.label }}:&nbsp;</span>
                }
                <span>{{ task?.label }}</span>
              </td>
              <td class="col-separator"></td>
              @if (GetShouldDisplayTaskLocationInTitle(task)) {
                <td>
                  <span>{{ GetTaskLocationString(task) }}</span>
                </td>
                <td class="col-separator"></td>
              }

              @switch (task.appointmentArrangement) {
                @case (appointmentArrangement.Required) {
                  <td>
                    <mat-icon
                      color="error"
                      style="
                        font-size: 16px;
                        width: 18px;
                        height: 18px;
                        transform: translateY(2px);
                        text-shadow:
                          -1px -1px 0 #fff4,
                          1px -1px 0 #fff4,
                          -1px 1px 0 #fff4,
                          1px 1px 0 #fff4;
                      "
                      i18n-title="@@AppointmentArrangement_Required_Tooltip"
                      title="Appointment must be made"
                      >perm_phone_msg</mat-icon
                    >
                  </td>
                }
                @case (appointmentArrangement.Scheduled) {
                  <td class="col-icon">
                    <mat-icon
                      style="
                        font-size: 16px;
                        width: 18px;
                        height: 18px;
                        transform: translateY(2px);
                      "
                      i18n-title="@@AppointmentArrangement_Scheduled_Tooltip"
                      title="Appointment scheduled"
                      >event</mat-icon
                    >
                  </td>
                }
              }
              @if (task.hasUnreadNotes) {
                <td class="col-icon">
                  <mat-icon
                    style="
                      font-size: 16px;
                      width: 18px;
                      height: 18px;
                      transform: translateY(2px);
                    "
                    i18n-title="@@TaskCard_HasUnreadNotes"
                    title="Task has unread notes"
                    >note</mat-icon
                  >
                </td>
              }
              @if (
                task.appointmentArrangement !== appointmentArrangement.None ||
                task.hasUnreadNotes
              ) {
                <td class="col-separator"></td>
              }
              @if (task.assignedToResourceID || task.claimResourceID) {
                @if (task.assignedToResourceID && !task.claimResourceID) {
                  <td class="col-icon" [title]="GetTooltipAssignedTo(task)">
                    <span class="fa fa-user"></span>
                  </td>
                }
                @if (task.claimResourceID) {
                  <td class="col-icon" [title]="GetTooltipClaimedBy(task)">
                    <span class="fa fa-user-check"></span>
                  </td>
                }
                <td class="col-separator"></td>
              }
              <td class="col-taskNo">
                <b>{{ task?.taskNoDisplay }}</b>
              </td>
              <td class="col-separator"></td>
              <td class="col-planned" [ngStyle]="GetPlannedForStyle(task)">
                {{ GetPlannedFor(task) }}
              </td>
            </tr>
            @if (displayResourceName) {
              <tr>
                @if (
                  resources &&
                  (task?.assignedToResourceID || task?.claimResourceID)
                ) {
                  <td colspan="20">
                    {{ GetResourceName(task) }}
                  </td>
                }
                @if (
                  !resources ||
                  (!task?.assignedToResourceID && !task?.claimResourceID)
                ) {
                  <td colspan="20">
                    <span i18n="@@@TaskCard_AssignedTo_TextWhenNotAssigned"
                      >Unassigned</span
                    >
                  </td>
                }
              </tr>
            }
            @if (GetShouldDisplayAnlageNr(task)) {
              <tr>
                <td [colSpan]="20">
                  <span i18n="@@FacilityNo">Facility-No.</span>:
                  <b>{{ task.anlageNrIntern }}</b>
                </td>
              </tr>
            }
            @if (GetShouldDisplayTaskLocation(task)) {
              <tr>
                <td [colSpan]="20">
                  <b>{{ GetTaskLocationString(task) }}</b>
                </td>
              </tr>
            }
          </table>
        </div>
      </div>
    }
  </div>
  <ng-template #template>
    <div class="cst-tooltip">
      <app-planung-task-card-tooltip
        [task]="task"
        [resources]="resources"
        [taskStates]="taskStates"
        [stateMeta]="stateMeta"
      >
      </app-planung-task-card-tooltip>
    </div>
  </ng-template>
}
